import { HttpUtil } from '../../../shared/util/http.util';
import { UserPageCriteria } from '../model/user-page-criteria';
import { Observable } from 'rxjs';
import { User } from '../model/user';
import { Injectable } from '@angular/core';
import { MockService } from '../../../shared/service/mock.service';
import generateUserMockData from '../../../../../mock/user.mock';
import { Page } from '../../../shared/model/local/pagination/page';

@Injectable({ providedIn: 'root' })
export class UserApiService {
  private mock: MockService<User, Page<User>> = new MockService(
    generateUserMockData()
  );

  constructor(private readonly httpUtil: HttpUtil) {}

  public getById(id: number): Observable<User> {
    return this.mock.getById(id);
  }

  public getPage(criteria: UserPageCriteria): Observable<Page<User>> {
    return this.mock.getPage(criteria);
  }

  public create(data: User): Observable<User> {
    return this.mock.create(data);
  }

  public delete(id: number): Observable<void> {
    return this.mock.delete(id);
  }

  public edit(id: number, data: User): Observable<User> {
    return this.mock.update(id, data);
  }
}
